import React from 'react';
import '../../App.css';
import {Button, Col, Form, Row} from "react-bootstrap";
import {helpdeskPhoneNumber} from "../../data";
import calllogo from "../../resources/ilet.png";
import {useHistory} from "react-router-dom";
import ahtapotLogo from "../../resources/ahtabotLogo.png";
import yts3glogo from "../../resources/ugyLogo.png";

function MainHeaderPart({tenantName,removeCookie,tabKey}) {

    let history = useHistory();

    const onExit = () => {
        removeCookie('subscriptionToken', {path: '/'});
        history.push('/subscription/login');
    }

    return (
        <Row>
            <Col lg={7} style={{"whiteSpace": "nowrap"}}>
                {tabKey === "ahtapot" ?
                    <img src={ahtapotLogo} style={{padding: 5, height: 75, width: 120}}
                         alt="Logo"/> :
                    <img src={yts3glogo} style={{height: 75, width: 75}}
                         alt="Logo"/>}{tenantName}
            </Col>
            <Col lg={{span: 4, offset: 1}} className="d-none d-lg-block">
                <Row
                    className="justify-content-end p-3 align-text-bottom align-middle align-items-center">
                    <Form.Label className="pr-3 align-middle">
                        {helpdeskPhoneNumber}
                    </Form.Label>
                    <img src={calllogo} alt="callLogo" width={50} height={50}/>
                    <div className="pl-2 pr-4">
                        <Button variant="danger" active onClick={onExit}>Çıkış</Button>
                    </div>
                </Row>
            </Col>
        </Row>
    );
}

export default MainHeaderPart;
